import { render, staticRenderFns } from "./fav-dialog.vue?vue&type=template&id=7c725456&scoped=true"
import script from "./fav-dialog.vue?vue&type=script&lang=js"
export * from "./fav-dialog.vue?vue&type=script&lang=js"
import style0 from "./fav-dialog.vue?vue&type=style&index=0&id=7c725456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c725456",
  null
  
)

export default component.exports